import { ContestIcon } from "../icons";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import Show from "./Show";

export default {
	options: {
		group: "gamification",
		roles: ["admin"],
	},
	icon: ContestIcon,
	list: List,
	edit: Edit,
	create: Create,
	show: Show,
};
